/* Calculator homedeko — logica de calcul și adăugare în coș */
(function () {
  'use strict';

  /* Grupul și rolul unei linii din coș: din „Configurație” + detaliile vizibile
     (cu compatibilitate pentru liniile vechi cu proprietăți _hdc_) */
  var CFG_KEY = 'Configurație';
  function hdcGroupOf(p) { p = p || {}; return p[CFG_KEY] || p._hdc_grup || null; }
  function hdcRoleOf(p) {
    p = p || {};
    if (p._hdc_rol) return p._hdc_rol;
    if (!p[CFG_KEY]) return null;
    if (p['Tip manoperă']) return 'material';
    if (p['Poziție']) return 'accesoriu';
    if (p['Serviciu pentru']) return 'serviciu';
    if (p['Total metraj material']) return 'manopera';
    return null;
  }
  var DIM_KEY = 'Dimensiuni pe bucată';
  function hdcDims(p) { p = p || {}; return String(p[DIM_KEY] || p['Dimensiuni'] || ''); }
  function hdcIsSplit2(p) { p = p || {}; return /panouri|în 2/i.test(String(p['Împărțire'] || p['Tip împărțire'] || '')); }
  // Textul pentru croitorie: câte panouri și ce lățime
  function hdcSplitText(len, split2, pcs) {
    if (split2) return '2 panouri × ' + (len / 2) + ' cm pe bucată' + (pcs > 1 ? ' (' + (pcs * 2) + ' panouri în total)' : '');
    return 'bucată întreagă' + (pcs > 1 ? ' (' + pcs + ' bucăți în total)' : '');
  }
  function hdcMetersPerPiece(p) {
    p = p || {};
    var u = parseInt(p._hdc_unitati, 10);
    if (u) return u;
    var m = hdcDims(p).match(/(\d+)/);
    return m ? Math.max(1, Math.round(parseInt(m[1], 10) / 100)) : 1;
  }

  var STEP = 100; // prețul este per 100 cm, deci lungimea merge din 100 în 100

  var COLOR_MAP = {
    'alb': '#ffffff', 'alb rece': '#f8fafc', 'alb cald': '#fdf8ee', 'ivory': '#fffff0', 'ivoire': '#fffff0',
    'crem': '#f5f0dc', 'bej': '#e9dfc9', 'nisip': '#d8c8a8', 'taupe': '#8b7d6b', 'maro': '#7c4a2d',
    'ciocolatiu': '#4b2e20', 'negru': '#111827', 'gri': '#9ca3af', 'gri deschis': '#d1d5db',
    'gri inchis': '#4b5563', 'gri închis': '#4b5563', 'antracit': '#383e42', 'grafit': '#41424c',
    'argintiu': '#c0c0c0', 'auriu': '#d4af37', 'verde': '#16a34a', 'verde olive': '#708238',
    'menta': '#98d7c2', 'albastru': '#2563eb', 'bleu': '#93c5fd', 'bleumarin': '#1e3a5f',
    'turcoaz': '#14b8a6', 'petrol': '#1f5f6b', 'mov': '#7c3aed', 'lila': '#c4b5fd', 'roz': '#ec4899',
    'roz pudrat': '#e8c4c4', 'rosu': '#dc2626', 'roșu': '#dc2626', 'bordo': '#7f1d1d',
    'galben': '#f59e0b', 'mustar': '#d4a017', 'muștar': '#d4a017', 'portocaliu': '#f97316', 'caramel': '#b8763c'
  };

  function formatMoney(cents, format) {
    format = String(format || '{{amount}} lei').replace(/<[^>]*>/g, '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function delim(n, precision, thousands, decimal) {
      var s = (n / 100).toFixed(precision);
      var parts = s.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(placeholder);
    if (!m) return delim(cents, 2, ',', '.');
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = delim(cents, 2, ' ', ','); break;
      default: v = delim(cents, 2, ',', '.');
    }
    return format.replace(placeholder, v);
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function toInt(v, fallback) {
    var n = parseInt(v, 10);
    return isNaN(n) ? fallback : n;
  }

  function snapUp(v) { return Math.ceil(v / STEP) * STEP; }

  function colorCss(name) {
    var key = String(name || '').trim().toLowerCase();
    if (COLOR_MAP[key]) return COLOR_MAP[key];
    if (window.CSS && CSS.supports && CSS.supports('color', key)) return key;
    return '#e5e7eb';
  }

  function init(root) {
    root.setAttribute('data-hdc-ready', '');
    var cfg;
    try { cfg = JSON.parse(root.querySelector('[data-hdc-config]').textContent); } catch (e) { return; }

    function q(s) { return root.querySelector(s); }
    var el = {
      length: q('[data-hdc-length]'),
      height: q('[data-hdc-height]'),
      qty: q('[data-hdc-qty]'),
      warn: q('[data-hdc-warn]'),
      manopera: q('[data-hdc-manopera]'),
      manWrap: q('[data-hdc-manopera-wrap]'),
      errMan: q('[data-hdc-err-manopera]'),
      errStock: q('[data-hdc-err-stock]'),
      mcard: q('[data-hdc-mcard]'),
      mimg: q('[data-hdc-mimg]'),
      mname: q('[data-hdc-mname]'),
      total: q('[data-hdc-total]'),
      meta: q('[data-hdc-meta]'),
      atc: q('[data-hdc-atc]')
    };

    // Limite curățate (lungimea mereu multiplu de 100)
    var L = {
      min: Math.max(STEP, snapUp(toInt(cfg.length.min, 100))),
      max: Math.floor(toInt(cfg.length.max, 3000) / STEP) * STEP,
      def: snapUp(toInt(cfg.length.def, 100))
    };
    if (L.max < L.min) L.max = L.min;
    L.def = Math.min(Math.max(L.def, L.min), L.max);
    var H = { min: toInt(cfg.height.min, 100), max: toInt(cfg.height.max, 280), def: toInt(cfg.height.def, 240) };
    if (H.max < H.min) H.max = H.min;
    H.def = Math.min(Math.max(H.def, H.min), H.max);

    var variantId = String(root.getAttribute('data-hdc-variant') || (cfg.variants[0] && cfg.variants[0].id));
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function msg(text, lim) {
      return String(text || '').replace(/\[min\]/g, lim.min).replace(/\[max\]/g, lim.max);
    }
    function readInt(input, fallback) {
      var d = String((input && input.value) || '').replace(/[^\d]/g, '');
      return d === '' ? fallback : parseInt(d, 10);
    }
    function setWarn(text) {
      if (!el.warn) return;
      el.warn.textContent = text || '';
      el.warn.hidden = !text;
    }
    function findVariant(id) {
      for (var i = 0; i < cfg.variants.length; i++) {
        if (String(cfg.variants[i].id) === String(id)) return cfg.variants[i];
      }
      return null;
    }
    function getSplit() {
      var r = root.querySelector('[data-hdc-split] input:checked');
      return r ? r.value : 'Bucată întreagă';
    }
    function selectedManopera() {
      if (!el.manopera || !el.manopera.value) return null;
      return el.manopera.options[el.manopera.selectedIndex];
    }

    /* ---------- Dimensiuni și cantitate ---------- */
    function commitLength(delta) {
      var raw = String(el.length.value || '').trim();
      var v = readInt(el.length, L.def);
      var warn = '';
      if (delta) {
        v = snapUp(v) + delta;
      } else if (raw !== '' && v % STEP !== 0) {
        warn = msg(cfg.msg.lengthStep, L);
      }
      v = snapUp(v);
      if (v < L.min) v = L.min;
      if (v > L.max) { v = L.max; warn = msg(cfg.msg.lengthMax, L); }
      el.length.value = v;
      setWarn(warn);
      calc();
    }
    function commitHeight(delta) {
      var v = readInt(el.height, H.def) + (delta || 0);
      var warn = '';
      if (v < H.min) { v = H.min; warn = msg(cfg.msg.heightMin, H); }
      else if (v > H.max) { v = H.max; warn = msg(cfg.msg.heightMax, H); }
      el.height.value = v;
      setWarn(warn);
      calc();
    }
    function commitQty(delta) {
      var v = readInt(el.qty, 1) + (delta || 0);
      if (v < 1) v = 1;
      el.qty.value = v;
      calc();
    }

    /* ---------- Culoare ---------- */
    function paintDots() {
      var dots = root.querySelectorAll('[data-hdc-dot]');
      for (var i = 0; i < dots.length; i++) dots[i].style.background = colorCss(dots[i].getAttribute('data-hdc-dot'));
    }
    function selectColor(val) {
      if (!cfg.colorIndex) return;
      var idx = cfg.colorIndex - 1, match = null, avail = null;
      cfg.variants.forEach(function (v) {
        if (String(v.options[idx]).trim() === String(val).trim()) {
          if (!match) match = v;
          if (!avail && v.available) avail = v;
        }
      });
      var pick = avail || match;
      if (pick) variantId = String(pick.id);
      var chips = root.querySelectorAll('[data-hdc-color]');
      for (var i = 0; i < chips.length; i++) {
        var on = chips[i].getAttribute('data-hdc-color') === val;
        chips[i].classList.toggle('is-on', on);
        chips[i].setAttribute('aria-checked', on ? 'true' : 'false');
      }
      if (el.errStock) el.errStock.hidden = true;
      calc();
    }

    /* ---------- Manoperă ---------- */
    function setManoperaState() {
      if (!el.manopera) return;
      var ok = !!el.manopera.value;
      el.manopera.classList.toggle('is-ok', ok);
      el.manopera.classList.toggle('is-pending', !ok);
      if (ok) el.manopera.classList.remove('is-error');
    }
    function updateManoperaCard() {
      var opt = selectedManopera();
      if (!opt || !el.mcard) { if (el.mcard) el.mcard.hidden = true; return; }
      var img = opt.getAttribute('data-img') || '';
      var title = opt.getAttribute('data-title') || '';
      if (img) {
        el.mimg.src = img; el.mimg.alt = title; el.mimg.parentNode.hidden = false;
        el.mimg.parentNode.setAttribute('data-src', bigImg(img));
        el.mimg.parentNode.setAttribute('data-alt', title);
      }
      else { el.mimg.removeAttribute('src'); el.mimg.parentNode.hidden = true; }
      el.mname.textContent = title;
      el.mcard.hidden = false;
    }
    function showManoperaError() {
      if (el.errMan) el.errMan.hidden = false;
      if (el.manopera) { el.manopera.classList.add('is-error'); setManoperaState(); el.manopera.classList.add('is-error'); }
      try { (el.manWrap || el.manopera).scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      try { el.manopera.focus({ preventScroll: true }); } catch (e) {}
    }

    /* ---------- Mostră de material ---------- */
    var sampleBtn = q('[data-hdc-sample]');
    var sampleColorEl = q('[data-hdc-sample-color]');
    var sampleErr = q('[data-hdc-err-sample]');

    function variantLabel(v) {
      if (!v) return '';
      if (cfg.colorIndex) return String(v.options[cfg.colorIndex - 1]);
      return v.title && v.title !== 'Default Title' ? String(v.title) : '';
    }
    function updateSampleLabel(v) {
      if (!sampleColorEl) return;
      var label = variantLabel(v);
      sampleColorEl.textContent = label ? ' · culoarea ' + label : '';
    }
    function addSample() {
      var v = findVariant(variantId);
      var label = variantLabel(v);
      var props = { 'Mostră pentru': cfg.productTitle };
      if (label) props['Culoare'] = label;
      if (v && v.sku) props['SKU'] = String(v.sku); // SKU-ul variantei din care s-a cerut mostra
      if (v) props['_hdc_mostra'] = String(v.id);
      props['_hdc_mostra_handle'] = cfg.productHandle; // în coș, mostra se afișează cu numele și poza acestui produs
      if (sampleErr) sampleErr.hidden = true;
      sampleBtn.disabled = true;
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(sampleBtn.getAttribute('data-variant')), quantity: 1, properties: props }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('sample ' + r.status); return r.json(); })
        .then(function () { sampleBtn.disabled = false; afterAdd(); })
        .catch(function (err) {
          console.error('[Calculator] mostră', err);
          sampleBtn.disabled = false;
          if (sampleErr) sampleErr.hidden = false;
        });
    }

    /* ---------- WhatsApp ---------- */
    var waEl = q('[data-hdc-wa]');
    function updateWhatsApp(v) {
      if (!waEl) return;
      var num = String(waEl.getAttribute('data-number') || '').replace(/\D/g, '');
      if (!num) return;
      var link = window.location.origin + cfg.productUrl + (v ? '?variant=' + v.id : '');
      var msg = String(cfg.waMessage || '')
        .replace(/\[produs\]/g, cfg.productTitle)
        .replace(/\[link\]/g, link)
        .replace(/\[culoare\]/g, variantLabel(v));
      waEl.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(msg);
    }


    /* ---------- Manoperă verticală (accesorii pe lateral) ---------- */
    var accEl = q('[data-hdc-acc]');
    var acc = { on: false, prod: null, vid: null, side: null, open: null };
    var ACC_SIDES = {
      '1': [
        { k: 'stanga', n: 'Lateral stânga', m: 1, e: [0] },
        { k: 'dreapta', n: 'Lateral dreapta', m: 1, e: [1] },
        { k: 'ambele', n: 'Ambele laterale', m: 2, e: [0, 1] }
      ],
      '2': [
        { k: 'interior', n: 'Laterale interior', m: 2, e: [1, 2] },
        { k: 'exterior', n: 'Laterale exterior', m: 2, e: [0, 3] },
        { k: 'interior-exterior', n: 'Interior + exterior', m: 4, e: [0, 1, 2, 3] }
      ]
    };
    function splitKey() { return /2/.test(getSplit()) ? '2' : '1'; }
    function accProduct(id) {
      var list = cfg.accessories || [];
      for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return list[i];
      return null;
    }
    function accVariant() {
      var p = accProduct(acc.prod);
      if (!p) return null;
      for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === String(acc.vid)) return p.variants[i];
      return null;
    }
    function accSide() {
      var list = ACC_SIDES[splitKey()];
      for (var i = 0; i < list.length; i++) if (list[i].k === acc.side) return list[i];
      return null;
    }
    function accIcon(sk, edges) {
      var panels = sk === '1' ? [[14, 64]] : [[8, 34], [46, 72]];
      var xs = sk === '1' ? [14, 64] : [8, 34, 46, 72];
      var svg = '<svg class="hdc-split__svg" viewBox="0 0 80 64" aria-hidden="true" focusable="false">' +
        '<line x1="4" y1="6" x2="76" y2="6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>';
      panels.forEach(function (r) {
        svg += '<rect x="' + r[0] + '" y="8" width="' + (r[1] - r[0]) + '" height="50" rx="1" fill="currentColor" fill-opacity=".12" stroke="currentColor" stroke-width="1"/>';
      });
      edges.forEach(function (i) {
        svg += '<line x1="' + xs[i] + '" y1="10" x2="' + xs[i] + '" y2="56" stroke="#c9a227" stroke-width="4" stroke-dasharray="2 4" stroke-linecap="round"/>';
      });
      return svg + '</svg>';
    }
    var CHECK = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    function accRender() {
      if (!accEl) return;
      q('[data-hdc-acc-body]').hidden = !acc.on;
      var sw = accEl.querySelectorAll('[data-hdc-acc-switch]');
      for (var i = 0; i < sw.length; i++) {
        var on = (sw[i].getAttribute('data-hdc-acc-switch') === '1') === acc.on;
        sw[i].classList.toggle('is-on', on);
        sw[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      var p = accProduct(acc.prod), v = accVariant(), side = accSide();
      var cards = accEl.querySelectorAll('[data-hdc-acc-pick]');
      for (var j = 0; j < cards.length; j++) cards[j].classList.toggle('is-on', cards[j].getAttribute('data-hdc-acc-pick') === String(acc.prod));

      // Pasul 2: culorile produsului ales
      if (p) {
        q('[data-hdc-acc-colors]').innerHTML = p.variants.map(function (vv) {
          var dot = vv.img ? 'background-image:url(' + vv.img + ');background-size:cover;background-position:center'
                           : 'background:' + colorCss(vv.name);
          return '<button type="button" class="hdc-color' + (String(vv.id) === String(acc.vid) ? ' is-on' : '') + '"' +
            (vv.available ? '' : ' disabled') + ' data-hdc-acc-color="' + vv.id + '">' +
            '<span class="hdc-color__dot" style="' + dot + '"></span><span>' + esc(vv.name) + '</span></button>';
        }).join('');
      }
      // Pasul 3: lateralele, în funcție de împărțirea materialului
      var sk = splitKey();
      q('[data-hdc-acc-sides]').innerHTML = ACC_SIDES[sk].map(function (o) {
        return '<label class="hdc-split__opt"><input type="radio" name="' + uidSeed + '-accside" value="' + o.k + '"' + (o.k === acc.side ? ' checked' : '') + ' data-hdc-acc-side>' +
          '<span class="hdc-split__ui">' + accIcon(sk, o.e) + '<span class="hdc-split__name">' + o.n + '<span class="hdc-wz__x">× ' + o.m + '</span></span><span class="hdc-badge">Selectat</span></span></label>';
      }).join('');

      // Starea pașilor: gata / activ / urmează
      var done = [false, !!p, !!v, !!side];
      var active = acc.open || (!done[1] ? 1 : !done[2] ? 2 : !done[3] ? 3 : 0);
      var prodImg = '';
      if (p) {
        var ci = accEl.querySelector('[data-hdc-acc-pick="' + p.id + '"] img');
        prodImg = ci ? ci.currentSrc || ci.src : '';
      }
      var sums = [
        '',
        p ? (prodImg ? '<img class="hdc-wz__thumb" src="' + prodImg + '" alt="">' : '') + '<span><strong>' + esc(p.title) + '</strong></span>' : '',
        v ? (v.img ? '<span class="hdc-zoomable hdc-wz__zoom" data-hdc-zoom data-src="' + bigImg(v.img) + '" data-alt="' + esc(p.title + ' – ' + v.name) + '"><img class="hdc-wz__thumb hdc-wz__thumb--lg" src="' + v.img.replace(/width=\d+/, 'width=240') + '" alt="' + esc(v.name) + '"><span class="hdc-zoom-ico" aria-hidden="true"><svg viewBox="0 0 24 24" width="13" height="13"><circle cx="10.5" cy="10.5" r="6" fill="none" stroke="currentColor" stroke-width="2.3"/><path d="M15 15l5 5" stroke="currentColor" stroke-width="2.3" stroke-linecap="round"/></svg></span></span>' : '') + '<span>Culoare: <strong>' + esc(v.name) + '</strong></span>' : '',
        side ? '<span class="hdc-wz__ico">' + accIcon(sk, side.e) + '</span><span><strong>' + side.n + '</strong> (× ' + side.m + ')</span>' : ''
      ];
      var items = accEl.querySelectorAll('[data-hdc-wz]');
      for (var k = 0; k < items.length; k++) {
        var n = k + 1, it = items[k];
        var st = n === active ? 'is-active' : (done[n] ? 'is-done' : 'is-todo');
        it.className = 'hdc-wz__item ' + st;
        it.querySelector('[data-hdc-wz-num]').innerHTML = st === 'is-done' ? CHECK : String(n);
        it.querySelector('[data-hdc-wz-sum]').innerHTML = st === 'is-done' ? sums[n] : '';
      }
    }
    var uidSeed = root.id || 'hdc';

    // Partea de manoperă verticală din calcul: cost (în bani) + text pentru rezumat
    function accCalc(hei, pcs) {
      if (!acc.on) return { cents: 0, complete: true, text: '' };
      var p = accProduct(acc.prod), v = accVariant(), side = accSide();
      var sum = q('[data-hdc-acc-sum]');
      if (!p || !v || !side) { if (sum) sum.hidden = true; return { cents: 0, complete: false, text: '' }; }
      var cmPerPiece = hei * side.m;
      var qty = cmPerPiece * pcs;
      var cents = v.price * qty;
      if (sum) {
        sum.hidden = false;
        sum.innerHTML = CHECK + '<span>Gata: ' + esc(p.title) + ' ' + esc(v.name) + ', ' + side.n.toLowerCase() +
          ' · ' + hei + ' cm × ' + side.m + (pcs > 1 ? ' × ' + pcs + ' buc' : '') + ' = ' + qty + ' cm → <strong>+ ' +
          formatMoney(cents, cfg.moneyFormat) + '</strong></span>';
      }
      return { cents: cents, complete: true, product: p, variant: v, side: side, qty: qty, cmPerPiece: cmPerPiece,
               text: ' – ' + (cfg.accTitle || 'Manoperă verticală').toLowerCase() + ': ' + esc(p.title) + ' ' + esc(v.name) + ', ' + side.n.toLowerCase() };
    }
    // Ce mai lipsește din manopera verticală (pasul și textul)
    function accMissing() {
      if (!accProduct(acc.prod)) return { n: 1, t: 'produsul, culoarea și lateralele' };
      if (!accVariant()) return { n: 2, t: 'culoarea și lateralele' };
      return { n: 3, t: 'lateralele' };
    }
    function scrollToStep(n) {
      var it = accEl.querySelector('[data-hdc-wz="' + n + '"]') || accEl;
      try { it.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      it.classList.remove('is-attn');
      void it.offsetWidth; // repornește animația
      it.classList.add('is-attn');
      setTimeout(function () { it.classList.remove('is-attn'); }, 1600);
    }
    function showAccError() {
      var err = q('[data-hdc-err-acc]');
      var m = accMissing();
      acc.open = null;
      accRender();
      if (err) {
        err.innerHTML =
          '<div class="hdc-acc__warn-t">Manopera verticală nu e completă</div>' +
          '<div>Mai ai de ales ' + m.t + ' (Pasul ' + m.n + ').</div>' +
          '<div class="hdc-acc__warn-a">' +
            '<button type="button" class="hdc-acc__warn-go" data-hdc-acc-goto="' + m.n + '">Continuă la Pasul ' + m.n + '</button>' +
            '<button type="button" class="hdc-acc__warn-skip" data-hdc-acc-skip>Adaugă în coș fără manoperă verticală</button>' +
          '</div>';
        err.hidden = false;
        try { err.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      }
    }
    function hideAccError() { var err = q('[data-hdc-err-acc]'); if (err) err.hidden = true; }

    if (accEl) {
      accEl.addEventListener('click', function (e) {
        var t;
        if ((t = e.target.closest('[data-hdc-acc-switch]'))) {
          acc.on = t.getAttribute('data-hdc-acc-switch') === '1';
          if (!acc.on) { acc.prod = null; acc.vid = null; acc.side = null; }
          acc.open = null;
        } else if ((t = e.target.closest('[data-hdc-acc-goto]'))) {
          e.preventDefault(); e.stopPropagation();
          hideAccError();
          scrollToStep(parseInt(t.getAttribute('data-hdc-acc-goto'), 10));
          return;
        } else if ((t = e.target.closest('[data-hdc-acc-skip]'))) {
          e.preventDefault(); e.stopPropagation();
          acc.on = false; acc.prod = null; acc.vid = null; acc.side = null; acc.open = null;
          hideAccError();
          accRender();
          calc();
          addToCart(); // fără manoperă verticală
          return;
        } else if ((t = e.target.closest('[data-hdc-acc-back]'))) {
          acc.open = parseInt(t.getAttribute('data-hdc-acc-back'), 10); // redeschide pasul, păstrând alegerile
        } else if ((t = e.target.closest('[data-hdc-acc-pick]'))) {
          var pid = t.getAttribute('data-hdc-acc-pick');
          if (String(acc.prod) !== pid) { acc.prod = pid; acc.vid = null; }
          var p = accProduct(pid);
          if (p && p.variants.length === 1 && p.variants[0].available) acc.vid = String(p.variants[0].id);
          acc.open = null;
        } else if ((t = e.target.closest('[data-hdc-acc-color]'))) {
          acc.vid = t.getAttribute('data-hdc-acc-color');
          acc.open = null;
        } else { return; }
        e.preventDefault();
        e.stopPropagation();
        hideAccError();
        accRender();
        calc();
      });
      accEl.addEventListener('change', function (e) {
        if (e.target.matches('[data-hdc-acc-side]')) {
          acc.side = e.target.value;
          acc.open = null;
          hideAccError();
          accRender();
          calc();
        }
      });
    }

    /* ---------- Bară sticky cu totalul ----------
       Apare cât timp clientul configurează produsul și dispare când zona cu „Total” e vizibilă pe ecran. */
    var sticky = null;
    var totalCard = el.total ? el.total.closest('.hdc-card') : null;
    function buildSticky() {
      if (!totalCard) return;
      sticky = document.createElement('div');
      sticky.className = 'hdc-sticky';
      sticky.setAttribute('style', root.getAttribute('style') || '');
      sticky.setAttribute('aria-hidden', 'true');
      sticky.innerHTML =
        '<div class="hdc-sticky__in">' +
          '<div class="hdc-sticky__info">' +
            '<span class="hdc-sticky__label">Total</span>' +
            '<span class="hdc-sticky__price" data-hdc-sticky-price></span>' +
            '<span class="hdc-sticky__meta" data-hdc-sticky-meta></span>' +
          '</div>' +
          '<button type="button" class="hdc-sticky__btn" data-hdc-sticky-atc tabindex="-1"></button>' +
        '</div>';
      document.body.appendChild(sticky);
      sticky.querySelector('[data-hdc-sticky-atc]').addEventListener('click', function () { addToCart(); });
    }
    function updateSticky(len, hei, pcs) {
      if (!sticky) return;
      sticky.querySelector('[data-hdc-sticky-price]').textContent = el.total.textContent;
      sticky.querySelector('[data-hdc-sticky-meta]').textContent = len + ' × ' + hei + ' cm · ' + pcs + ' buc';
      sticky.querySelector('[data-hdc-sticky-atc]').textContent = el.atc.textContent;
    }
    var stickyTick = false;
    function checkSticky() {
      stickyTick = false;
      if (!sticky) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var t = totalCard.getBoundingClientRect();
      var r = root.getBoundingClientRect();
      var totalVisible = t.top < vh && t.bottom > 0;
      var started = r.top < vh * 0.85;            // clientul a ajuns la calculator
      var show = started && !totalVisible && root.offsetParent !== null;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      sticky.querySelector('[data-hdc-sticky-atc]').tabIndex = show ? 0 : -1;
    }
    function onScroll() {
      if (stickyTick) return;
      stickyTick = true;
      window.requestAnimationFrame(checkSticky);
    }


    /* ---------- Serviciu opțional (încrețire rejansă + cârlige) ---------- */
    var svcOn = false;
    var svcWrap = q('[data-hdc-svc]');
    var svcCheck = q('[data-hdc-svc-check]');
    function svcEligible() {
      if (!cfg.svc || !svcWrap) return false;
      var opt = selectedManopera();
      if (!opt) return false;
      var name = String(opt.getAttribute('data-title') || '').trim().toLowerCase();
      for (var i = 0; i < cfg.svc.manopere.length; i++) {
        if (String(cfg.svc.manopere[i]).trim() === name) return true;
      }
      return false;
    }
    function svcRender() {
      if (!svcWrap) return;
      var ok = svcEligible();
      svcWrap.hidden = !ok;
      if (!ok) svcOn = false;            // manoperă fără serviciu: se scoate automat
      if (svcCheck) svcCheck.checked = svcOn;
      svcWrap.classList.toggle('is-on', svcOn);
    }
    if (svcCheck) svcCheck.addEventListener('change', function () { svcOn = svcCheck.checked; svcRender(); calc(); });

    /* ---------- Mărire poze (lupă + fereastră cu X) ---------- */
    function bigImg(url) { return String(url || '').replace(/([?&])width=\d+/, '$1width=1600'); }
    var zoomBox = null, zoomPrevFocus = null;
    function closeZoom() {
      if (!zoomBox) return;
      zoomBox.classList.remove('is-open');
      document.documentElement.classList.remove('hdc-zoom-lock');
      if (zoomPrevFocus) try { zoomPrevFocus.focus(); } catch (e) {}
    }
    function openZoom(src, alt) {
      if (!src) return;
      if (!zoomBox) {
        zoomBox = document.createElement('div');
        zoomBox.className = 'hdc-zoom';
        zoomBox.setAttribute('role', 'dialog');
        zoomBox.setAttribute('aria-modal', 'true');
        zoomBox.innerHTML = '<button type="button" class="hdc-zoom__close" aria-label="Închide"><svg viewBox="0 0 24 24" width="26" height="26"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg></button><img class="hdc-zoom__img" alt="">';
        document.body.appendChild(zoomBox);
        zoomBox.addEventListener('click', function (e) { if (!e.target.closest('.hdc-zoom__img') || e.target.closest('.hdc-zoom__close')) closeZoom(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
      }
      var im = zoomBox.querySelector('.hdc-zoom__img');
      im.src = src; im.alt = alt || '';
      zoomPrevFocus = document.activeElement;
      zoomBox.classList.add('is-open');
      document.documentElement.classList.add('hdc-zoom-lock');
      try { zoomBox.querySelector('.hdc-zoom__close').focus(); } catch (e) {}
    }

    /* ---------- Calcul ---------- */
    function calc() {
      var len = snapUp(readInt(el.length, L.def));
      len = Math.min(Math.max(len, L.min), L.max);
      var hei = Math.min(Math.max(readInt(el.height, H.def), H.min), H.max);
      var pcs = Math.max(1, readInt(el.qty, 1));
      var meters = (len / STEP) * pcs; // cantitatea trimisă în coș = metri totali

      var variant = findVariant(variantId);
      var basePrice = variant ? variant.price : 0;
      var opt = selectedManopera();
      var manPrice = opt ? toInt(opt.getAttribute('data-price'), 0) : 0;
      var manName = opt ? opt.getAttribute('data-title') : '';

      var accPart = accCalc(hei, pcs);
      var svcActive = svcOn && svcEligible();
      var svcCents = svcActive ? cfg.svc.price * meters : 0;
      el.total.textContent = formatMoney((basePrice + manPrice) * meters + svcCents + accPart.cents, cfg.moneyFormat);
      updateSampleLabel(variant);
      var stockEl = q('[data-hdc-stock]');
      if (stockEl) {
        var inStock = !!(variant && variant.available);
        stockEl.textContent = inStock ? 'În stoc' : 'Stoc epuizat';
        stockEl.classList.toggle('is-out', !inStock);
        var etaEl = q('[data-hdc-eta-line]');
        if (etaEl && !inStock) etaEl.hidden = true;
        else if (etaEl && window.hdcRenderEta && etaEl.hidden && etaEl.textContent) etaEl.hidden = false;
      }
      updateSticky(len, hei, pcs);
      updateWhatsApp(variant);
      el.meta.innerHTML = '(' + len + 'cm lățime x ' + hei + 'cm înălțime – manoperă: ' +
        (manName ? esc(manName) : '<span class="hdc-missing">neselectată</span>') +
        (svcActive ? ' + ' + esc(String(cfg.svc.title).toLowerCase()) : '') +
        accPart.text + ') × ' + pcs + ' buc';

      return {
        len: len, hei: hei, pcs: pcs, meters: meters, variant: variant,
        manoperaId: opt ? opt.value : '', manoperaName: manName, split: getSplit(), acc: accPart,
        svc: svcActive
      };
    }

    /* ---------- Coș ---------- */
    function afterAdd() {
      // Pasul următor: deschiderea coșului lateral Kalles.
      // Până atunci, clientul ajunge pe pagina coșului.
      if (typeof window.hdcOpenCart === 'function') { window.hdcOpenCart(); return; }
      window.location.href = rootUrl + 'cart';
    }

    function addToCart() {
      if (document.activeElement === el.length) commitLength(0);
      if (document.activeElement === el.height) commitHeight(0);
      if (document.activeElement === el.qty) commitQty(0);

      var s = calc();
      if (!s.variant || !s.variant.available) { el.errStock.hidden = false; return; }
      el.errStock.hidden = true;
      if (!s.manoperaId) { showManoperaError(); return; }
      if (!s.acc.complete) { showAccError(); return; }

      var dims = s.len + ' × ' + s.hei + ' cm';
      // Cod scurt, vizibil pe toate liniile configurației: leagă produsul de manoperă în coș și în comandă
      var ABC = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', code = '#';
      for (var ci = 0; ci < 5; ci++) code += ABC.charAt(Math.floor(Math.random() * ABC.length));
      var items = [
        {
          id: Number(s.manoperaId),
          quantity: s.meters,
          properties: {
            'Pentru produs': cfg.productTitle,
            'Dimensiuni pe bucată': dims,
            'Total metraj material': s.meters + ' m',
            'Configurație': code
          }
        },
        {
          id: Number(s.variant.id),
          quantity: s.meters,
          properties: {
            'Tip manoperă': s.manoperaName,
            'Bucăți': String(s.pcs),
            'Dimensiuni pe bucată': dims,
            'Împărțire': hdcSplitText(s.len, /2/.test(s.split), s.pcs),
            'Total metraj material': s.meters + ' m',
            'Configurație': code
          }
        }
      ];
      if (s.svc) {
        var mpS = items[1].properties;
        delete mpS['Configurație'];
        mpS['Serviciu'] = cfg.svc.title;
        mpS['Configurație'] = code;
        items.unshift({
          id: Number(cfg.svc.id),
          quantity: s.meters,
          properties: {
            'Pentru produs': cfg.productTitle,
            'Serviciu pentru': s.manoperaName,
            'Dimensiuni pe bucată': dims,
            'Total metraj material': s.meters + ' m',
            'Configurație': code
          }
        });
      }
      if (s.acc.qty) {
        // „Manoperă verticală” se pune înaintea codului de configurație
        var mp = items[1].properties;
        delete mp['Configurație'];
        mp[cfg.accTitle || 'Manoperă verticală'] = s.acc.product.title + ', ' + s.acc.variant.name + ', ' + s.acc.side.n.toLowerCase();
        mp['Configurație'] = code;
        items.unshift({ // trimis primul => afișat ultimul în coș (Produs, Manoperă, Manoperă verticală)
          id: Number(s.acc.variant.id),
          quantity: s.acc.qty, // în cm
          properties: {
            'Pentru produs': cfg.productTitle,
            'Poziție': s.acc.side.n,
            'Înălțime': s.hei + ' cm',
            'Total': s.acc.qty + ' cm',
            'Configurație': code
          }
        });
      }

      el.atc.disabled = true;
      var oldLines = edit.lines;
      var removeOld = oldLines
        ? postJson('cart/update.js', { updates: oldLines.reduce(function (o, l) { o[l.key] = 0; return o; }, {}) })
        : Promise.resolve();

      removeOld
        .then(function () { return postJson('cart/add.js', { items: items }); })
        .then(function (data) {
          el.atc.disabled = false;
          if (oldLines) endEdit();
          document.dispatchEvent(new CustomEvent('hdc:added', { detail: data }));
          afterAdd();
        })
        .catch(function (err) {
          console.error('[Calculator]', err);
          if (!oldLines) { el.atc.disabled = false; el.errStock.hidden = false; return; }
          // Adăugarea a eșuat: punem la loc produsul vechi, ca să nu se piardă din coș
          var restore = oldLines.slice().reverse().map(function (l) { return { id: l.variant_id, quantity: l.quantity, properties: l.properties }; });
          postJson('cart/add.js', { items: restore })
            .catch(function (e) { console.error('[Calculator] restore', e); })
            .then(function () {
              return fetchCart().then(function (cart) { edit.lines = groupLines(cart, edit.group); });
            })
            .then(function () { el.atc.disabled = false; el.errStock.hidden = false; });
        });
    }

    /* ---------- Editare din coș (?hdc_edit=COD) ---------- */
    var edit = { group: null, lines: null, banner: null, atcText: el.atc.textContent };

    function postJson(url, body) {
      return fetch(rootUrl + url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; }, function () { throw new Error('HTTP ' + r.status); });
        return r.json();
      });
    }
    function fetchCart() {
      return fetch(rootUrl + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    }
    function groupLines(cart, group) {
      return cart.items.filter(function (it) { return hdcGroupOf(it.properties) === group; });
    }
    function byRole(lines, rol) {
      for (var i = 0; i < lines.length; i++) if (hdcRoleOf(lines[i].properties) === rol) return lines[i];
      return null;
    }
    function markColorOfVariant(v) {
      if (!cfg.colorIndex || !v) return;
      var val = String(v.options[cfg.colorIndex - 1]);
      var chips = root.querySelectorAll('[data-hdc-color]');
      for (var i = 0; i < chips.length; i++) {
        var on = chips[i].getAttribute('data-hdc-color') === val;
        chips[i].classList.toggle('is-on', on);
        chips[i].setAttribute('aria-checked', on ? 'true' : 'false');
      }
    }
    function cleanUrl() {
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('hdc_edit');
        history.replaceState(null, '', u.pathname + u.search + u.hash);
      } catch (e) {}
    }
    function endEdit() {
      edit.group = null;
      edit.lines = null;
      if (edit.banner) edit.banner.remove();
      edit.banner = null;
      el.atc.textContent = edit.atcText;
      cleanUrl();
    }
    function startEdit(group) {
      el.atc.disabled = true;
      fetchCart().then(function (cart) {
        var lines = groupLines(cart, group);
        var mat = byRole(lines, 'material');
        var variant = mat ? findVariant(mat.variant_id) : null;
        if (!variant) { el.atc.disabled = false; cleanUrl(); return; } // nu mai e în coș sau e alt produs

        var p = mat.properties;
        var dims = hdcDims(p).match(/(\d+)\D+(\d+)/);
        var units = hdcMetersPerPiece(p);
        var len = parseInt(p._hdc_lungime, 10) || (dims ? parseInt(dims[1], 10) : units * STEP);
        var hei = parseInt(p._hdc_inaltime, 10) || (dims ? parseInt(dims[2], 10) : H.def);
        var pcs = parseInt(p['Bucăți'], 10) || Math.max(1, Math.round(mat.quantity / units));

        variantId = String(variant.id);
        markColorOfVariant(variant);
        el.length.value = len;
        el.height.value = hei;
        el.qty.value = pcs;

        var radios = root.querySelectorAll('[data-hdc-split] input');
        var anySplit = false;
        for (var i = 0; i < radios.length; i++) {
          radios[i].checked = (/2/.test(radios[i].value) === hdcIsSplit2(p));
          if (radios[i].checked) anySplit = true;
        }
        if (!anySplit && radios[0]) radios[0].checked = true;

        var man = byRole(lines, 'manopera');
        if (man && el.manopera) {
          el.manopera.value = String(man.variant_id);
          if (el.manopera.value !== String(man.variant_id)) el.manopera.value = '';
          setManoperaState();
          updateManoperaCard();
        }
        svcOn = !!byRole(lines, 'serviciu');
        svcRender();

        var accLine = byRole(lines, 'accesoriu');
        if (accEl) {
          acc = { on: false, prod: null, vid: null, side: null, open: null };
          if (accLine && accProduct(accLine.product_id)) {
            acc.on = true;
            acc.prod = String(accLine.product_id);
            acc.vid = String(accLine.variant_id);
            acc.side = accLine.properties._hdc_acc_side || null;
            if (acc.side === 'un-lateral') acc.side = 'stanga';
            if (!acc.side && accLine.properties['Poziție']) { // din numele poziției
              ['1', '2'].forEach(function (k) {
                ACC_SIDES[k].forEach(function (o) { if (o.n === accLine.properties['Poziție']) acc.side = o.k; });
              });
            }
          }
          accRender();
        }

        edit.group = group;
        edit.lines = lines;
        el.atc.textContent = 'Actualizează în coș';
        edit.banner = document.createElement('div');
        edit.banner.className = 'hdc-edit-banner';
        edit.banner.innerHTML = '<span>Modifici un produs din coș. La final apasă „Actualizează în coș”.</span>' +
          '<button type="button" class="hdc-edit-banner__cancel">Renunță</button>';
        edit.banner.querySelector('button').addEventListener('click', endEdit);
        root.insertBefore(edit.banner, root.firstChild);

        el.atc.disabled = false;
        calc();
        try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
      }).catch(function () { el.atc.disabled = false; });
    }

    /* ---------- Evenimente ---------- */
    root.addEventListener('click', function (e) {
      var zoomEl = e.target.closest('[data-hdc-zoom]');
      if (zoomEl && zoomEl.getAttribute('data-src')) {
        e.preventDefault(); e.stopPropagation();
        openZoom(zoomEl.getAttribute('data-src'), zoomEl.getAttribute('data-alt'));
        return;
      }
      var stepBtn = e.target.closest('[data-hdc-step]');
      if (stepBtn) {
        var dir = toInt(stepBtn.getAttribute('data-dir'), 1);
        var kind = stepBtn.getAttribute('data-hdc-step');
        if (kind === 'length') commitLength(dir * STEP);
        else if (kind === 'height') commitHeight(dir);
        else if (kind === 'qty') commitQty(dir);
        return;
      }
      var chip = e.target.closest('[data-hdc-color]');
      if (chip) { selectColor(chip.getAttribute('data-hdc-color')); return; }
      if (e.target.closest('[data-hdc-atc]')) { e.preventDefault(); addToCart(); return; }
      if (e.target.closest('[data-hdc-sample]')) { e.preventDefault(); addSample(); }
    });

    [[el.length, commitLength], [el.height, commitHeight], [el.qty, commitQty]].forEach(function (pair) {
      var input = pair[0], commit = pair[1];
      if (!input) return;
      input.addEventListener('blur', function () { commit(0); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); commit(0); input.blur(); }
      });
    });
    if (el.qty) el.qty.addEventListener('input', calc);

    if (el.manopera) {
      el.manopera.addEventListener('change', function () {
        if (el.errMan) el.errMan.hidden = true;
        el.errStock.hidden = true;
        setManoperaState();
        updateManoperaCard();
        svcRender();
        calc();
      });
    }
    var radios = root.querySelectorAll('[data-hdc-split] input');
    for (var i = 0; i < radios.length; i++) radios[i].addEventListener('change', function () {
      acc.side = null; // lateralele diferă între bucată întreagă și împărțită în 2
      acc.open = null;
      accRender();
      calc();
    });

    /* ---------- Pornire ---------- */
    el.length.value = L.def;
    el.height.value = H.def;
    buildSticky();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    paintDots();
    accRender();
    svcRender();
    setManoperaState();
    updateManoperaCard();
    calc();

    var editParam = null;
    try { editParam = new URLSearchParams(window.location.search).get('hdc_edit'); } catch (e) {}
    if (editParam) startEdit(editParam);
    checkSticky();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-hdc]:not([data-hdc-ready])');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();